import {
  AdjustmentType,
  IPriceRuleAdjustment,
  IPriceRuleRounding,
  RoundingMethod,
  RoundingType,
} from '../../types/price.types';
import { IPriceBandFields, IRuleCalculationFields } from 'src/types/priceRules';

export const getRoundingValue = (data: IPriceRuleRounding): number | null => {
  if (data.type === RoundingType.NONE) return null;

  if (data.method === RoundingMethod.SPECIFIC) {
    if (data.value) {
      const numValue = Number(data.value);
      return parseFloat(numValue.toFixed(2));
    }
    return null;
  }

  if (data.method === RoundingMethod.INTERVAL) {
    return data.value ? Number(data.value) : null;
  }

  return null;
};

export const createPriceRuleRounding = (rounding: IPriceBandFields['rounding']): IPriceRuleRounding => {
  if (rounding.type === RoundingType.NONE) {
    return { type: rounding.type };
  }

  return {
    type: rounding.type,
    method: rounding.method,
    value: Number(rounding.value),
  };
};

export const createPriceRuleAdjustment = (adjustment: IPriceBandFields['adjustment']) => {
  let value: number | undefined = undefined;
  switch (adjustment.type) {
    case AdjustmentType.FIXED:
      value = Number(adjustment.fixed);
      break;
    case AdjustmentType.PERCENTAGE:
      value = Number(adjustment.percentage);
      break;
    default:
      break;
  }

  return {
    type: adjustment.type,
    value,
  };
};

export const defaultRoundingValues = (rounding: IPriceRuleRounding): Partial<IPriceRuleRounding> => {
  if (rounding === undefined) {
    return { type: RoundingType.NONE };
  }

  const { type, method, value } = rounding;
  return { type, method, value };
};

export const defaultAdjustmentValues = (
  adjustment: IPriceRuleAdjustment,
): Partial<IRuleCalculationFields['adjustment']> => {
  if (adjustment === undefined) {
    return { type: AdjustmentType.NONE };
  }

  const { type, value } = adjustment;
  return {
    type: type,
    fixed: type === AdjustmentType.FIXED ? value : undefined,
    percentage: type === AdjustmentType.PERCENTAGE ? value : undefined,
  };
};
